module.exports = __webpack_public_path__ + "static/img/ste-catherine.9a7b959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ste-catherine.jpg
// module id = KIsD
// module chunks = 1